import producer from 'immer';
import { Reducer } from 'redux';
import { DocumentState, DocumentType } from './types';

const INITIAL_STATE: DocumentState = {
  data: [],
  editData: null,
  areas: [],
  changeInsert: '',
  resetPage: 0,
  contato: [],
  cleanModal: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<DocumentState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DocumentType.DOCUMENT_RESQUEST:
      return producer(state, draft => {
        draft.loading = true;
      });
    case DocumentType.DOCUMENT_SUCCESS:
      return producer(state, draft => {
        draft.data = action.payload.data;
        draft.loading = false;
      });
    case DocumentType.DOCUMENT_FAILURE:
      return producer(state, draft => {
        draft.loading = false;
        draft.error = true;
      });
    case DocumentType.GET_DOCUMENT_RESQUEST:
      return producer(state, draft => {
        draft.loading = true;
      });
    case DocumentType.GET_DOCUMENT_SUCCESS:
      return producer(state, draft => {
        draft.editData = action.payload.data;
        draft.loading = false;
      });
    case DocumentType.GET_DOCUMENT_FAILURE:
      return producer(state, draft => {
        draft.loading = false;
        draft.error = true;
      });
    case DocumentType.CONTRATO_RESQUEST:
      return producer(state, draft => {
        draft.loading = false;
      });
    case DocumentType.CONTRATO_SUCCESS:
      return producer(state, draft => {
        draft.contato = action.payload.data;
      });
    case DocumentType.CONTRATO_FAILURE:
      return producer(state, draft => {
        draft.loading = false;
        draft.error = true;
      });
    case DocumentType.MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST:
      return producer(state, draft => {
        draft.loading = false;
      });
    case DocumentType.GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST:
      return producer(state, draft => {
        draft.loading = false;
      });
    case DocumentType.GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST:
      return producer(state, draft => {
        draft.loading = false;
      });
    case DocumentType.MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS:
      return producer(state, draft => {
        draft.data = action.payload.data;
        draft.loading = true;
      });

    case DocumentType.CHANGE_INSERT:
      return producer(state, draft => {
        draft.changeInsert = action.payload.make;
      });
    case DocumentType.RESET_PAGE:
      return producer(state, draft => {
        draft.resetPage = draft.resetPage + 1;
      });
    case DocumentType.CLEAN_MODAL:
      return producer(state, draft => {
        draft.cleanModal = draft.cleanModal + 1;
      });

    default:
      return state;
  }
};

export default reducer;
